/* Merchant-owned variant presentation. Debut remains responsible for prices, cart and subscriptions. */
(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.DojiVariants = api;
})(typeof window !== 'undefined' ? window : this, function() {
  'use strict';

  // Shopify's assigned variant image begins a group, ending before the next assigned image.
  // Images before the first group remain shared. Products without assignments show everything.
  function galleryIds(images, variants, variant) {
    if (!variant || !variant.featured_image) return images.map(function(image) { return image.id; });
    var start = images.findIndex(function(image) { return image.id === variant.featured_image.id; });
    if (start < 0) return images.map(function(image) { return image.id; });
    var assigned = variants.filter(function(v) { return v.featured_image; }).map(function(v) { return v.featured_image.id; });
    var first = images.findIndex(function(image) { return assigned.indexOf(image.id) !== -1; });
    var end = images.length;
    for (var i = start + 1; i < images.length; i++) {
      if (assigned.indexOf(images[i].id) !== -1) { end = i; break; }
    }
    return images.filter(function(image, index) { return index < first || (index >= start && index < end); }).map(function(image) { return image.id; });
  }

  function optionState(variants, selected, index, value) {
    var matches = variants.filter(function(variant) {
      return variant.options.every(function(option, position) {
        return position > index || option === (position === index ? value : selected[position]);
      });
    });
    return { exists: matches.length > 0, available: matches.some(function(v) { return v.available; }) };
  }

  function init(section, product, showImage) {
    if (!section.hasAttribute('data-doji-native') || section.hasAttribute('data-doji-ready')) return;
    var data = JSON.parse(section.querySelector('[data-doji-media]').textContent);
    var selects = Array.from(section.querySelectorAll('.single-option-selector'));
    var radios = Array.from(section.querySelectorAll('[data-doji-option]'));
    var description = section.querySelector('[data-doji-description]');
    var defaultDescription = description.innerHTML;
    var activeDescription = null;
    var restock = section.querySelector('[data-doji-restock]');
    var restockVariants = restock ? restock.getAttribute('data-restock-variants').split(',') : [];

    function update(variant) {
      var selected = selects.map(function(select) { return select.value; });
      radios.forEach(function(radio) {
        var index = Number(radio.getAttribute('data-doji-option'));
        radio.checked = selected[index] === radio.value;
        var state = optionState(product.variants, selected, index, radio.value);
        radio.disabled = !state.exists;
        radio.closest('label').setAttribute('data-sold-out', String(state.exists && !state.available));
      });
      section.querySelectorAll('[data-doji-option-label]').forEach(function(label, index) { label.textContent = selected[index]; });
      section.querySelectorAll('[data-doji-title]').forEach(function(title) {
        title.textContent = product.title + (variant && variant.title !== 'Default Title' ? ' - ' + variant.options.join(' - ') : '');
      });
      var template = variant && section.querySelector('[data-doji-variant-description="' + variant.id + '"]');
      var descriptionKey = template ? variant.id : 'default';
      if (descriptionKey !== activeDescription) {
        description.innerHTML = template ? template.innerHTML : defaultDescription;
        activeDescription = descriptionKey;
      }
      if (restock) {
        var canRequest = variant && !variant.available && restockVariants.indexOf(String(variant.id)) !== -1;
        restock.hidden = !canRequest;
        if (canRequest) {
          var destination = new URL(restock.getAttribute('data-restock-url'), window.location.origin);
          if (destination.origin !== window.location.origin) destination = new URL('/pages/restock-alerts', window.location.origin);
          destination.searchParams.set('variant', String(variant.id));
          restock.querySelector('a').href = destination.pathname + destination.search;
          restock.querySelector('[data-restock-choice]').textContent = product.title + ' - ' + variant.options.join(' - ');
        }
      }
      var ids = galleryIds(data.images, product.variants, variant);
      section.querySelectorAll('.product-single__thumbnails-item').forEach(function(item) {
        item.hidden = ids.indexOf(Number(item.querySelector('[data-thumbnail-id]').getAttribute('data-thumbnail-id'))) === -1;
      });
      var gallery = section.querySelector('.thumbnails-wrapper');
      if (gallery) gallery.hidden = ids.length < 2;
      if (variant && variant.featured_image) showImage(variant.featured_image.id);
    }

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (!radio.checked) return;
        var select = selects[Number(radio.getAttribute('data-doji-option'))];
        select.value = radio.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    window.jQuery(section).on('doji:variant', function(event) { update(event.variant); });
    var initial = product.variants.find(function(variant) {
      return variant.options.every(function(value, index) { return selects[index] && selects[index].value === value; });
    }) || product.variants[0];
    update(initial);
    section.setAttribute('data-doji-ready', '');
    var options = section.querySelector('[data-doji-options]');
    if (options) options.hidden = false;
  }
  return { init: init, galleryIds: galleryIds, optionState: optionState };
});
